/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Error_DescriptionInputs */

const en_offline_error_description = /** @type {(inputs: Offline_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Closed Caption Creator application is not available in the current environment. This could be due to network connectivity issues, server maintenance, or configuration problems.`)
};

const fr_offline_error_description = /** @type {(inputs: Offline_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'application Closed Caption Creator n'est pas disponible dans l'environnement actuel. Cela peut être dû à des problèmes de connectivité réseau, une maintenance du serveur ou des problèmes de configuration.`)
};

const de_offline_error_description = /** @type {(inputs: Offline_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Anwendung zur Erstellung von Untertiteln ist in der aktuellen Umgebung nicht verfügbar. Dies kann an Problemen mit der Netzwerkverbindung, Serverwartungsarbeiten oder Konfigurationsproblemen liegen.`)
};

const it_offline_error_description = /** @type {(inputs: Offline_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'applicazione "Closed Caption Creator" non è disponibile nell'ambiente attuale. Ciò potrebbe essere dovuto a problemi di connettività di rete, manutenzione del server o problemi di configurazione.`)
};

const ru_offline_error_description = /** @type {(inputs: Offline_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приложение для создания субтитров недоступно в текущей среде. Это может быть связано с проблемами сетевого подключения, техническим обслуживанием сервера или проблемами с конфигурацией.`)
};

const es_offline_error_description = /** @type {(inputs: Offline_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La aplicación Creador de subtítulos no está disponible en este entorno. Esto podría deberse a problemas de conectividad de red, mantenimiento del servidor o problemas de configuración.`)
};

const zh_cn2_offline_error_description = /** @type {(inputs: Offline_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前环境下无法使用字幕创建工具。这可能是由于网络连接问题、服务器维护或配置问题导致的。`)
};

const ja_offline_error_description = /** @type {(inputs: Offline_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在の環境では、Closed Caption Creator アプリケーションはご利用いただけません。ネットワーク接続の問題、サーバーメンテナンス、または設定の問題が原因である可能性があります。`)
};

const hi_offline_error_description = /** @type {(inputs: Offline_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान परिवेश में क्लोज्ड कैप्शन क्रिएटर एप्लिकेशन उपलब्ध नहीं है। इसका कारण नेटवर्क कनेक्टिविटी संबंधी समस्याएं, सर्वर रखरखाव या कॉन्फ़िगरेशन संबंधी समस्याएं हो सकती हैं।`)
};

const pt_pt2_offline_error_description = /** @type {(inputs: Offline_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O aplicativo Criador de Legendas Ocultas não está disponível no ambiente atual. Isso pode ser devido a problemas de conectividade de rede, manutenção do servidor ou problemas de configuração.`)
};

/**
* | output |
* | --- |
* | "The Closed Caption Creator application is not available in the current environment. This could be due to network connectivity issues, server maintenance, or ..." |
*
* @param {Offline_Error_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_error_description = /** @type {((inputs?: Offline_Error_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Error_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_error_description(inputs)
	if (locale === "de") return de_offline_error_description(inputs)
	if (locale === "it") return it_offline_error_description(inputs)
	if (locale === "ru") return ru_offline_error_description(inputs)
	if (locale === "es") return es_offline_error_description(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_error_description(inputs)
	if (locale === "ja") return ja_offline_error_description(inputs)
	if (locale === "hi") return hi_offline_error_description(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_error_description(inputs)
	return en_offline_error_description(inputs)
});